export function getReimbursementSummary(items) {
  const total = (items || []).reduce((sum, item) => sum + Number(item.amount || 0), 0);
  const paid = (items || [])
    .filter((item) => item.status === "paid")
    .reduce((sum, item) => sum + Number(item.amount || 0), 0);

  return { total, paid, unpaid: total - paid };
}

export function getCashAdvanceSummary(items, month, year) {
  const total = (items || []).reduce((sum, item) => sum + Number(item.total_amount || 0), 0);
  const currentPeriodDeduction = (items || [])
    .filter((item) => item.status === "approved" || item.status === "lunas")
    .flatMap((item) => item.schedule || [])
    .filter((installment) => Number(installment.month) === Number(month) && Number(installment.year) === Number(year))
    .reduce((sum, installment) => sum + Number(installment.amount || 0), 0);

  return { total, currentPeriodDeduction };
}

export function isCashAdvanceInPeriod(item, month, year) {
  if (item?.schedule?.length) {
    return item.schedule.some((installment) =>
      Number(installment.month) === Number(month) && Number(installment.year) === Number(year)
    );
  }

  const date = String(item?.date || item?.created_at || "").trim();
  const dmy = date.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (dmy) return Number(dmy[2]) === Number(month) && Number(dmy[3]) === Number(year);

  const iso = date.match(/^(\d{4})-(\d{2})/);
  return !!iso && Number(iso[2]) === Number(month) && Number(iso[1]) === Number(year);
}
